import { useSpotDetailAttachedStateMachine } from './detail/useSpotDetailAttachedStateMachine'
import { useSpotsFetchStateMachine } from './useSpotsFetchStateMachine'

/**
 * スポット一覧ページの統合フック。
 * - useSpotsFetchStateMachine: スポット取得・タブ・フィルタ・ARフォトオーバーレイ
 * - useSpotDetailAttachedStateMachine: ARフォトロック・音声ガイドダイアログ（詳細ページと共通）
 */
export const useSpotListStateMachine = ({ isAuthenticated }: { isAuthenticated: boolean }) => {
  const list = useSpotsFetchStateMachine({ isAuthenticated })
  const attached = useSpotDetailAttachedStateMachine()

  return {
    list,
    attached,
  }
}
